import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { OnlinePreflight } from './OnlinePreflight'
import { ArtworkAssistantProps } from './types'

export const ArtworkAssistant: FC<ArtworkAssistantProps> = ({
  seo,
  header,
  footer,
  content: {
    breadcrumb,
    title,
    subtitle,
    description,
    dieline_generator,
    shape,
    dimension,
    diameter,
    width,
    height,
    options,
    opaque,
    foil,
    download_button,
    asserts_group,
    file_checker,
    sorts_title,
    sorts,
    upload_button,
    upload_text,
    drag_and_drop,
    how_does_it_work_title,
    how_does_it_work_content,
    how_to_use_title,
    how_to_use_content,
    tutorial_title,
    tutorial_content,
    triangle_visible,
    preflight_mistakes,
    professional_assistance,
    artwork_service_long_text,
    artwork_service_button,
    artwork_service_image,
    preflight_success,
    success_long_text,
    calculator_button,
    calculator_link,
    artwork_service_link,
    first_waiting_text,
    second_waiting_text,
    login_model
  }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured breadcrumb={breadcrumb} title={title} subtitle={subtitle} description={description} />
    <OnlinePreflight
      dieline_generator={dieline_generator}
      shape={shape}
      dimension={dimension}
      diameter={diameter}
      width={width}
      height={height}
      options={options}
      opaque={opaque}
      foil={foil}
      download_button={download_button}
      asserts_group={asserts_group}
      file_checker={file_checker}
      sorts_title={sorts_title}
      sorts={sorts}
      upload_button={upload_button}
      upload_text={upload_text}
      drag_and_drop={drag_and_drop}
      how_does_it_work_title={how_does_it_work_title}
      how_does_it_work_content={how_does_it_work_content}
      how_to_use_title={how_to_use_title}
      how_to_use_content={how_to_use_content}
      tutorial_title={tutorial_title}
      tutorial_content={tutorial_content}
      triangle_visible={triangle_visible}
      preflight_mistakes={preflight_mistakes}
      professional_assistance={professional_assistance}
      artwork_service_long_text={artwork_service_long_text}
      artwork_service_button={artwork_service_button}
      artwork_service_image={artwork_service_image}
      preflight_success={preflight_success}
      success_long_text={success_long_text}
      calculator_button={calculator_button}
      calculator_link={calculator_link}
      artwork_service_link={artwork_service_link}
      first_waiting_text={first_waiting_text}
      second_waiting_text={second_waiting_text}
      login_model={login_model}
    />
  </Page>
)
